import {GitMergeIcon, GitPullRequestIcon} from '@primer/octicons-react'
import styles from './PullRequestSection.module.css'
import conversationStyles from './ConversationList.module.css'
import type {PullRequestDataPoint} from '../types'
import {pluralize, createRelativeTimeProps} from '../helpers/infographic-helpers'
import {Link, RelativeTime} from '@primer/react'

interface PullRequestSectionProps {
  type: 'merged' | 'opened'
  count?: number
  peopleCount?: number
  pullRequests?: PullRequestDataPoint[]
}

const DEFAULT_PULL_REQUESTS: PullRequestSectionProps['pullRequests'] = []

export function PullRequestSection({
  type,
  count = 0,
  peopleCount = 0,
  pullRequests = DEFAULT_PULL_REQUESTS,
}: PullRequestSectionProps) {
  const Icon = type === 'merged' ? GitMergeIcon : GitPullRequestIcon
  const iconClass = type === 'merged' ? 'color-fg-done' : 'color-fg-success'
  const title =
    type === 'merged' ? `${pluralize(count, 'pull request')} merged` : `${pluralize(count, 'pull request')} opened`
  const sectionId = type === 'merged' ? 'merged-pull-requests' : 'opened-pull-requests'

  return pullRequests && pullRequests.length > 0 ? (
    <section className={styles.section}>
      <div>
        <h3 className={conversationStyles.conversationListHeading} id={sectionId}>
          <span className={conversationStyles.inner}>
            <Icon className={iconClass} /> <strong className="color-fg-default">{count}</strong> {title} by{' '}
            <strong className="color-fg-default">{peopleCount}</strong> {pluralize(peopleCount, 'person', 'people')}
          </span>
        </h3>
      </div>

      <ul className="list-style-none my-4">
        {pullRequests && pullRequests.length > 0 ? (
          pullRequests.map(pr => (
            <li key={pr.number} className="clearfix">
              <Icon className={`${iconClass} float-left mt-1`} />
              <div className="overflow-hidden pl-2">
                <Link href={pr.path} className="h4 Link--primary mb-1 markdown-title">
                  {pr.title}
                </Link>
                <p className="color-fg-muted text-small">
                  <span className="num">#{pr.number}</span> {type}{' '}
                  <RelativeTime {...createRelativeTimeProps(pr.mergedAt ?? pr.createdAt)} />
                </p>
              </div>
            </li>
          ))
        ) : (
          <li className="clearfix">
            <Icon className={`${iconClass} float-left mt-1`} />
            <div className="overflow-hidden pl-2">
              <a href="filler" className="h4 Link--primary mb-1 markdown-title">
                [Example PR]
              </a>
              <p className="color-fg-muted text-small">
                <span className="num">#0000</span> {type} yesterday
              </p>
            </div>
          </li>
        )}
      </ul>
    </section>
  ) : null
}
